const RECEIVE_BLOCK_CONTENT = "RECEIVE_BLOCK_CONTENT";
const REQUEST_BLOCK_CONTENT = "REQUEST_BLOCK_CONTENT";
const SET_BLOCK_CONTENT = "SET_BLOCK_CONTENT";

export const ContentBlockTypes = {
  RECEIVE_BLOCK_CONTENT,
  REQUEST_BLOCK_CONTENT,
  SET_BLOCK_CONTENT
};
